import React from "react";

function ArrowLeftOrange() {
  return (
    <svg className="navigation-direction-icon"
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33802 9.99062L0.227351 5.67981L0.213992 5.6658L0.206798 5.65933L0.200632 5.65179L0.193438 5.64317L0.1883 5.6367L0.180079 5.627L0.171857 5.61622L0.156442 5.59359L0.145138 5.5785L0.134861 5.56342L0.124585 5.54725V5.54078L0.115336 5.53109V5.52354V5.51492L0.104031 5.50522V5.49875L0.0906715 5.48582C0.0110102 5.32905 -0.0172571 5.14915 0.0102293 4.97387C0.0377156 4.79858 0.119429 4.63765 0.242766 4.51589L4.33802 0.226632C4.48345 0.079468 4.67818 -0.00190691 4.88027 3.39368e-05C5.08236 0.00197478 5.27564 0.0870761 5.41848 0.237008C5.56131 0.386941 5.64228 0.589708 5.64394 0.801637C5.6456 1.01357 5.56782 1.2177 5.42735 1.37007L2.63312 4.30035H15.1594C15.3638 4.30035 15.5598 4.38551 15.7044 4.53709C15.8489 4.68867 15.9301 4.89426 15.9301 5.10863C15.9301 5.32299 15.8489 5.52858 15.7044 5.68016C15.5598 5.83175 15.3638 5.9169 15.1594 5.9169H2.63312L5.42735 8.84825C5.50308 8.92225 5.56381 9.01149 5.60594 9.11063C5.64807 9.20978 5.67072 9.31681 5.67254 9.42534C5.67437 9.53387 5.65533 9.64167 5.61657 9.74231C5.5778 9.84296 5.52011 9.93438 5.44692 10.0111C5.37373 10.0879 5.28655 10.1484 5.19057 10.189C5.0946 10.2297 4.99181 10.2497 4.88832 10.2478C4.78483 10.2458 4.68277 10.2221 4.58822 10.1779C4.49368 10.1337 4.40858 10.07 4.33802 9.99062Z"
        fill="#FA9C03"
      />
    </svg>
  );
}

export default ArrowLeftOrange;
